import { render, staticRenderFns } from "./zitable.vue?vue&type=template&id=61eed362&scoped=true&"
import script from "./zitable.vue?vue&type=script&lang=js&"
export * from "./zitable.vue?vue&type=script&lang=js&"
import style0 from "./zitable.vue?vue&type=style&index=0&id=61eed362&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eed362",
  null
  
)

export default component.exports